import { Field, NumericInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetBalanceFieldSet } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';
import { useSelector } from 'react-redux';

let WholePortionStandardPreDriedPreparationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const lightweightAggregate: boolean = useSelector(
    createWorksheetSelector!('data.Preparation.LightweightAggregate', false)
  );

  return (
    <NamePrefixModifier appendNamePrefix="Masses.MassMeasurement">
      <ListFieldSection>
        {/* The same balance is used to measure TareMass and TareAndDryMass. Copying
      the value is a simple workaround that avoids implementing a config function
      for `measuredUsing`.  */}
        <WorksheetBalanceFieldSet name="Equipment.Balance" copyTo={['Equipment.DryMassBalance']} />
        <Field input={<NumericInput />} name="BulkDensity" visible={lightweightAggregate} />
        <Field input={<NumericInput />} name="TareMass" />
        <Field input={<NumericInput />} name="TareAndDryMass" />
        <Field input={<TextOutput />} name="DryMass" />
        <Field input={<TextOutput />} name="Volume" visible={lightweightAggregate} />
      </ListFieldSection>
    </NamePrefixModifier>
  );
};

WholePortionStandardPreDriedPreparationSection = withInjectedProps(WholePortionStandardPreDriedPreparationSection);

export { WholePortionStandardPreDriedPreparationSection };
export default WholePortionStandardPreDriedPreparationSection;
